import React from 'react';
import { useFilterController } from '../../../../application/useFilterController';
import { useDebouncedValue } from '../../../hooks/useDebouncedValue';

// Zip Code and City are mutually exclusive -- typing in one clears the
// other immediately (matches the top nav search bar's smart-detect
// behavior). This also sidesteps a separate, pre-existing backend bug
// where combining zipcode/city with 2+ other filters returns wrong
// results -- the backend bug itself is still open and tracked separately.
export const LocationDrawerSection = () => {
  const { zipcode, setZipcode, city, setCity } = useFilterController();

  const { local: zipLocal, setLocal: setZipLocal } = useDebouncedValue(zipcode, setZipcode);
  const { local: cityLocal, setLocal: setCityLocal } = useDebouncedValue(city, setCity);

  const handleZipChange = (value: string) => {
    setZipLocal(value);
    if (value.trim() && cityLocal) {
      setCityLocal('');
      setCity(undefined);
    }
  };

  const handleCityChange = (value: string) => {
    setCityLocal(value);
    if (value.trim() && zipLocal) {
      setZipLocal('');
      setZipcode(undefined);
    }
  };

  return (
    <div className="p-4">
      <h3 className="text-lg font-semibold text-gray-900 pb-2">Location</h3>
      <div className="text-xs text-gray-500 mb-2">Search by zip code or city (not both).</div>
      <div className="grid grid-cols-2 gap-3">
        <div>
          <div className="text-xs text-gray-500 mb-2">Zip Code</div>
          <input
            type="text"
            placeholder="Enter zip code"
            value={zipLocal}
            onChange={(e) => handleZipChange(e.target.value)}
            className="w-full border rounded px-3 py-2 focus:outline-none focus:border-blue-500"
          />
        </div>
        <div>
          <div className="text-xs text-gray-500 mb-2">City</div>
          <input
            type="text"
            placeholder="Enter city"
            value={cityLocal}
            onChange={(e) => handleCityChange(e.target.value)}
            className="w-full border rounded px-3 py-2 focus:outline-none focus:border-blue-500"
          />
        </div>
      </div>
    </div>
  );
};
